import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';

interface NewPropertyModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCreateProperty: (name: string) => void;
}

export function NewPropertyModal({ open, onOpenChange, onCreateProperty }: NewPropertyModalProps) {
  const [propertyName, setPropertyName] = useState('');

  const handleCreate = () => {
    if (propertyName.trim()) {
      onCreateProperty(propertyName);
      setPropertyName('');
      onOpenChange(false);
    }
  };

  const handleCancel = () => {
    setPropertyName('');
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[480px] gap-0">
        <DialogHeader className="pb-6">
          <DialogTitle className="text-[20px] tracking-[-0.01em]">Nowy Projekt</DialogTitle>
          <DialogDescription className="text-[14px] text-muted-foreground mt-2">
            Utwórz folder dla nowej sesji zdjęciowej.
          </DialogDescription>
        </DialogHeader>

        <div className="pb-6">
          <div className="space-y-3">
            <Label htmlFor="property-name" className="text-[13px]">Nazwa lub Adres</Label>
            <Input
              id="property-name"
              placeholder="np. Apartament Mokotów"
              value={propertyName}
              onChange={(e) => setPropertyName(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleCreate();
                }
              }}
              className="bg-input-background border-border h-11 text-[14px]"
              autoFocus
            />
          </div>
        </div>

        <DialogFooter className="gap-2 sm:gap-2">
          <Button
            variant="outline"
            onClick={handleCancel}
            className="text-[14px]"
          >
            Anuluj
          </Button>
          <Button
            onClick={handleCreate}
            disabled={!propertyName.trim()}
            className="text-[14px] shadow-sm"
          >
            Utwórz
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}